<ng-select
  style="margin-bottom: 1rem"
  [items]="operators"
  [addTag]="false"
  [hideSelected]="false"
  appendTo="body"
  [(ngModel)]="formControl.value.operator"
  (ngModelChange)="onChangeOperator($event)"
>
  <ng-template ng-label-tmp let-item="item" let-clear="clear">
    <span class="ng-value-label"> {{ item.label | translate }}</span>
  </ng-template>
  <ng-template ng-option-tmp let-item="item">
    {{ item.label | translate }}</ng-template
  >
</ng-select>

<multiple-country-selector
  [readonly]="readonly"
  [defaultValues]="formControl.value.codes"
  (selectedValuesChange)="change($event)"
  [transformControlValueAccessorValue]="valueTransformFn"
></multiple-country-selector>
